module.exports = __webpack_public_path__ + "s/img/Chill_M_4.ed9793cb.jpg";